var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    width: "1em",
    height: "0.83em",
    viewBox: "0 0 42 42"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3.9,
    width: 42,
    height: 34.1,
    id: "b_00000057856282819032095400000006368617474882458782_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a_00000178197693123594620300000018036249530415850171_",
    className: "st1",
    d: "M0,3.9h42v34.1H0V3.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8,4.6c-1.7,1-3.5,1.7-5.5,2.1c-1.6-1.7-3.9-2.7-6.3-2.7c-4.8,0-8.6,3.9-8.6,8.6c0,0.7,0.1,1.3,0.2,2 c-7.2-0.4-13.5-3.8-17.8-9C2.2,6.8,1.8,8.3,1.8,9.8c0,2.9,1.4,5.6,3.8,7.2c-1.4,0-2.7-0.4-3.9-1.1V16c0,4.2,3,7.7,6.9,8.4 c-1.3,0.3-2.6,0.4-3.9,0.1c1.1,3.4,4.3,5.9,8,6C9.7,33,5.9,34.3,2.1,34.3c-0.7,0-1.4,0-2.1-0.1c3.9,2.5,8.5,3.9,13.2,3.9 c15.9,0,24.5-13.1,24.5-24.5c0-0.4,0-0.7,0-1.1c1.7-1.2,3.1-2.7,4.3-4.5c-1.6,0.7-3.2,1.2-4.9,1.4C38.9,8.3,40.2,6.6,40.8,4.6"
  })));
};
export default SvgTwitter;